// extracted by mini-css-extract-plugin
export var card = "PackageCard-module--card--747cc";
export var content = "PackageCard-module--content--070ed";
export var cta = "PackageCard-module--cta--10ff2";
export var footer = "PackageCard-module--footer--f9011";
export var header = "PackageCard-module--header--669cf";
export var subtitle = "PackageCard-module--subtitle--f2a55";
export var title = "PackageCard-module--title--cc529";